







import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
@Component
export default class FitTips extends Vue {
  @Prop({ default: '' })text;
  @Prop({ default: 300 })timeGap;// 时间间隔
  animateTime='0ms';

  @Watch('text')
  setAnimateTime() {
    const el = this.$refs.inner;
    if (!el) {
      this.animateTime = '0ms';
    } else {
      // @ts-ignore
      this.animateTime = `${(el.offsetWidth / this.timeGap)}s`;
    }
  }

  mounted() {
    this.setAnimateTime();
  }
}
